export default __webpack_public_path__ + "static/media/fish-dark.af3ddd7d.svg";